<template>
  <div>
    <template v-if="getUser.super_admin">
      <ReportPromoSA/>
    </template>
  </div>
</template>

<script>
import TitlePage from "../components/utils/TitlePage";
import ReportPromoSA from "@/components/admin/ReportPromoSA";
import {mapGetters} from "vuex";

export default {
  name: 'ReportPromoSuperAdmin',
  components: {ReportPromoSA,TitlePage},
  data() {
    return {

    };
  },

  computed: {
    ...mapGetters({
      'getUser': 'user/getUser',
    }),
  },
  methods: {

  },
  mounted() {

  },

}
</script>